import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_title, { value: "Child Diary" }),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-6 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { fluid: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.class')), 1),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.classFilterValue,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classFilterValue) = $event)),
                      items: _ctx.classesWithAllOption,
                      "item-title": (item) => item.classId === 'all' ? item.className : `(${item.year}) ${item.className}`,
                      "item-value": "classId",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      clearable: "",
                      disabled: _ctx.isFetching
                    }, null, 8, ["modelValue", "items", "item-title", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.date')), 1),
                    _createVNode(_component_date_picker, {
                      modelValue: _ctx.dateFilterValue,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateFilterValue) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "mt-4 search-button",
                      color: "primary",
                      variant: "flat",
                      size: "large",
                      disabled: !_ctx.isSearchValid,
                      loading: _ctx.isFetching,
                      onClick: _ctx.searchBtn
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_table, { class: "mt-4" }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "text-left" }, "Child Name"),
            _createElementVNode("th", { class: "text-left" }, "Class"),
            _createElementVNode("th", { class: "text-left" }, "Date"),
            _createElementVNode("th", { class: "text-left" }, "Gender"),
            _createElementVNode("th", { class: "text-left" }, "Attendance"),
            _createElementVNode("th", { class: "text-left" })
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diaries, (d) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: d.child.childId
            }, [
              _createElementVNode("td", null, _toDisplayString(d.child.lastName) + " " + _toDisplayString(d.child.firstName), 1),
              _createElementVNode("td", null, _toDisplayString(d.diary ? _ctx.getClassName(d.diary) : _ctx.getChildClassName(d.child)), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(d.diary ? d.diary?.date : _ctx.preDateFilterValue)), 1),
              _createElementVNode("td", null, _toDisplayString(d.child.gender === "male" ? _ctx.$t('common.male') : _ctx.$t('common.female')), 1),
              _createElementVNode("td", null, _toDisplayString(d.diary ? _ctx.getAttendance(d.diary) : _ctx.getChildAttendance(d.child)), 1),
              (d.diary)
                ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "flat",
                      width: "100px",
                      to: `/dailyreport/child/${d.child.childId}/${d.diary.date}`,
                      disabled: _ctx.isFetching
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "disabled"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_2, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "outlined",
                      width: "100px",
                      onClick: ($event: any) => (_ctx.newDiary(d.child.childId, _ctx.preDateFilterValue)),
                      disabled: _ctx.isFetching
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_pagination, {
      class: "pt-4",
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event)),
        _ctx.pageClick
      ],
      length: Math.ceil(_ctx.totalItemsCount / _ctx.limit)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "length"])
  ]))
}